var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "image-panel" },
      [
        _c("app-image", {
          attrs: {
            image: _vm.imageUrl,
            alt: _vm.value.title,
            cropped: _vm.isImgix ? null : _vm.cropped,
            size: _vm.isImgix ? null : _vm.size,
          },
        }),
        !_vm.sortable
          ? _c("form-text", {
              attrs: {
                placeholder: "Add a description",
                "field-size": "is-small",
                name: _vm.imageName,
                "has-counter": true,
                maxlength: 150,
              },
            })
          : _vm._e(),
        _c("div", { staticClass: "image-actions" }, [
          !_vm.sortable
            ? _c(
                "span",
                { staticClass: "has-text-grey", on: { click: _vm.onDelete } },
                [
                  _c("dc-icon", {
                    attrs: {
                      icon: "trash",
                      "no-margin": "",
                      "left-margin": "",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm.sortable
            ? _c(
                "span",
                { staticClass: "has-text-grey" },
                [
                  _c("dc-icon", {
                    attrs: { icon: "bars", "no-margin": "", "left-margin": "" },
                  }),
                ],
                1
              )
            : _vm._e(),
        ]),
        _vm.tag
          ? _c("span", {
              staticClass: "tag is-black is-small",
              domProps: { textContent: _vm._s(_vm.tag) },
            })
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }